/// <reference types="vite-plugin-svgr/client" />
import { Box, Link as MuiLink, Paper } from '@mui/material';
import { Link, Outlet } from 'react-router-dom';

import Logo from '~/assets/images/logo-black.svg?react';
import { useManageChat } from '~/modules/@shared/hooks/useManageChat';

function VerifyLayout() {
  useManageChat({ close: true });

  return (
    <Box sx={{ backgroundColor: 'background.secondary' }}>
      <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box
          sx={{
            position: 'absolute',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            py: 3.75,
            m: 'auto',
          }}>
          {/* Logo */}
          <MuiLink component={Link} to="/" sx={{ display: 'inline-block' }}>
            <Logo />
          </MuiLink>
        </Box>

        <Paper
          sx={{
            width: '50%',
            padding: 9,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Outlet />
        </Paper>
      </Box>
    </Box>
  );
}

export default VerifyLayout;
